import React, { FC, memo } from 'react';

import { TEXTS } from '../../texts';

import styles from './index.module.scss';

interface ModalDescriptionProps {
  addressHasStream: boolean;
  isAddressEnabled?: boolean;
}

const ModalDescription: FC<ModalDescriptionProps> = ({ addressHasStream, isAddressEnabled }) => {
  if (!addressHasStream) {
    return <div className={styles.description}>{TEXTS.MODAL_BIND_SUCCESS_NO_STREAM_DESC}</div>;
  }

  const successBindDeviceDescription = isAddressEnabled
    ? TEXTS.MODAL_BIND_SUCCESS_DESC
    : TEXTS.MODAL_BIND_SUCCESS_ADDRESS_NO_ACTIVE_DESC;

  return <div className={styles.description}>{successBindDeviceDescription}</div>;
};

export default memo(ModalDescription);
